<script setup lang="ts">
import type { PlayerTapConfig } from '@/types/shared/player-config'
import { usePlayer } from '@/composables/game/player'

defineProps<{
  tapConfig: PlayerTapConfig
}>()

defineEmits<{
  (e: 'upgrade', upgradeId: 'tap' | 'energy'): void
}>()

const { player } = usePlayer()
</script>

<template>
  <div>
    <div>
      <h3>Multitap</h3>
      Level: {{ tapConfig.tap.level }} <br>
      Price: {{ tapConfig.tap.price }} <br>
      <button
        :disabled="tapConfig.tap.price > player.coins"
        @click="$emit('upgrade', 'tap')"
      >
        Level Up
      </button>
    </div>
    <div>
      <h3>Energy</h3>
      Level: {{ tapConfig.energy.level }} <br>
      Price: {{ tapConfig.energy.price }} <br>
      <button
        :disabled="tapConfig.energy.price > player.coins"
        @click="$emit('upgrade', 'energy')"
      >
        Level Up
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
